<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidemenu mode="side" [opened]="true" class="sidenav">
    <mat-nav-list>
      <div class="sideMenu">
        @for (item of navigationSideMenu; track item) {
          <a mat-list-item [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="[item.link]" routerLinkActive="active" matTooltip={{item.tooltip}}
            matTooltipClass="custom-tooltip">
            <i matListItemIcon class="img-icon {{item.cssClass}}"></i>
            <span matListItemTitle>{{item.label}}</span>
          </a>
        }
      </div>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
